import React , {
    useCallback, useContext, useEffect, useState
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import classNames from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication } from 'gw-digital-auth-react';
import { isEmpty, checkEmailValidity } from '../LoginUtil';
import { useValidation } from 'gw-portals-validation-react';

import messages from './ProfileUpdateComponent.messages';
import metadata from './ProfileUpdateComponent.metadata.json5';
import styles from '../CommonLogin.module.scss';



function ProfileUpdateComponent() {

    const translator = useContext(TranslatorContext);
    const { isComponentValid, onValidate } = useValidation('ProfileUpdateComponent');
    const [profileUpdated, setProfileUpdated] = useState(false);
    const [pageError, updatePageError] = useState();
    const [profileVM, setProfileVM] = useState({});

    const {
        authHeader, getProfileData, updateProfileData, updateAuthUsername
    } = useAuthentication();
    const auth = useAuthentication();

    const fillProfileData = (data) => {
        const profile = {};
        profile.currentUserName = data.res.userName;
        profile.currentPhoneNumber = data.res.phoneNumbers && data.res.phoneNumbers.length > 0 ? data.res.phoneNumbers[0].value : null;
        return profile;
    };

    useEffect(() => {
        if (auth.user_name !== null) {
            getProfileData(auth.user_name, authHeader)
                .then((data) => {
                    setProfileVM(fillProfileData(data));
                })
                .catch((err) => {
                   // console.log('Error in getting profile data');
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleUpdateDetails = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }
            setProfileUpdated(false);
           
            if (isEmpty(profileVM.newPhoneNumber) && isEmpty(profileVM.newUserName)) {
                updatePageError('Please enter the new email/phone number to update');
                return Promise.resolve();
            }

            profileVM.newUserName = profileVM.newUserName ? profileVM.newUserName.trim() : profileVM.newUserName
            profileVM.newPhoneNumber = profileVM.newPhoneNumber ? profileVM.newPhoneNumber.trim() : profileVM.newPhoneNumber

            if ((!isEmpty(profileVM.newPhoneNumber)) && (_.isEqual(profileVM.currentPhoneNumber, profileVM.newPhoneNumber))) {
                updatePageError('Your current phone number and new phone number are the same. Please enter a new phone number and try again.');
                return Promise.resolve();
            }

            if ((!isEmpty(profileVM.newUserName)) && (_.isEqual(profileVM.currentUserName, profileVM.newUserName))) {
                updatePageError('Your old email ID and current email ID (username) are the same. Please enter a new email ID and try again.');
                return Promise.resolve();
            }

            if ((!isEmpty(profileVM.newUserName)) && (!checkEmailValidity(profileVM.newUserName))) {
                updatePageError('Please enter a valid email to update');
                return Promise.resolve();
            }

            if (!isEmpty(profileVM.newPhoneNumber)) {
                const phoneNumber = profileVM.newPhoneNumber;
                if (phoneNumber.replace('_', '').length !== 12) {
                    updatePageError('Please enter a valid phone number to update');
                    return Promise.resolve();
                }
            }


            updatePageError('');
            if(profileVM.newPhoneNumber === ""){
                profileVM.newPhoneNumber = undefined
            }

            return updateProfileData(profileVM, authHeader)
                .then((data) => {
                    updateAuthUsername(data.res.userName);
                    setProfileVM(fillProfileData(data));
                    setProfileUpdated(true);
                })
                .catch((err) => {
                    if(err && err.baseError && err.baseError.endsWith('Error Code: 306 username already exists')){
                        updatePageError('The email you are trying to update is already in use.  Please update the information and try again.');
                    } else if(err && err.baseError && err.baseError.endsWith('Error Code: 306 Phone Number already exists')) {
                        updatePageError('The phone number you are trying to update is already in use.  Please update the information and try again.');
                    } else {
                        updatePageError('Server Error, Not able to update');
                    }
                });
        },
        [authHeader, profileVM, updateAuthUsername, updateProfileData]
    );

    const readValue = useCallback((id, path) => _.get(profileVM, path), [profileVM]);
    const writeValue = useCallback(
        (value, path) => setProfileVM({
            ...profileVM,
            [path]: value
        }),
        [profileVM]
    );


    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
    };

    const overrides = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsgContainer: {
            visible: !_.isUndefined(pageError) && pageError !== ''
        },
        errorMsg: {
            message: pageError
        },
        successMsgContainer: {
            visible: profileUpdated
        },
        currentEmail: {
            value: profileVM.userName
        },
        currentMobileNumber: {
            value: profileVM.currentPhoneNumber
        },
        updateEmailBtn: {
            onClick: handleUpdateDetails
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

ProfileUpdateComponent.propTypes = {
};

export default withRouter(ProfileUpdateComponent);
